import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M100 158c-22.5.4-44.6-5.5-63.6-17-17-11-26.4-25.5-26.4-41 .1-8 2.5-15.9 7.1-22.6 5-7.4 11.6-13.7 19.3-18.5 19-11.5 41.1-17.4 63.6-17 22.5-.4 44.6 5.5 63.6 17 7.7 4.8 14.3 11.1 19.3 18.5 4.6 6.7 7 14.6 7.1 22.6 0 15.5-9.4 30.1-26.4 41-19 11.6-41.1 17.5-63.6 17zm0-94.6c-7.6 0-15 2.1-21.3 6.2-6.3 4-11.2 9.7-14.1 16.4-2.9 6.7-3.7 14.1-2.2 21.2s5.1 13.6 10.5 18.7 12.2 8.6 19.6 10 15.2.7 22.2-2.1 13-7.5 17.2-13.5c4.2-6 6.5-13.1 6.5-20.3 0-9.7-4.1-19-11.3-25.9-7.2-6.8-16.9-10.7-27.1-10.7zm0 62.6c-5.4 0-10.7-1.5-15.1-4.4-4.5-2.9-8-6.9-10-11.7-2.1-4.7-2.6-10-1.5-15s3.6-9.7 7.5-13.3c3.8-3.6 8.7-6.1 13.9-7.1 5.3-1 10.8-.5 15.7 1.5 5 2 9.2 5.3 12.2 9.6s4.6 9.3 4.6 14.4c0 6.9-2.9 13.5-8 18.4-5.2 4.8-12.1 7.6-19.3 7.6z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
  ], 4))
}